{
  "title": "الأدلة",
  "subtitle": "أدلة العمل خطوة بخطوة لفريق منتهى الإنجاز",
  "updated": "آخر تحديث: {{date}}",
  "contents": "المحتويات",
  "pdf": {
    "ar": "تحميل PDF (العربية)",
    "en": "تحميل PDF (الإنجليزية)"
  },
  "backToTop": "العودة للأعلى",
  "notFound": "الدليل غير موجود",
  "table": "جدول (يمكن تمريره أفقياً)"
}
